"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _Auth = _interopRequireDefault(require("FileManagerCore/reducers/Auth"));

var _Folders = _interopRequireDefault(require("FileManagerCore/reducers/Folders"));

var _Files = _interopRequireDefault(require("FileManagerCore/reducers/Files"));

var _Canva = _interopRequireDefault(require("FileManagerCore/reducers/Canva"));

var _Dropbox = _interopRequireDefault(require("FileManagerCore/reducers/Dropbox"));

var _UserSettings = _interopRequireDefault(require("FileManagerCore/reducers/UserSettings"));

var _UploadingFiles = _interopRequireDefault(require("FileManagerCore/reducers/UploadingFiles"));

var _Limits = _interopRequireDefault(require("FileManagerCore/reducers/Limits"));

var _ActionTypes = require("FileManagerLib/actions/ActionTypes");

var _Panel = _interopRequireDefault(require("FileManagerLib/reducers/Panel"));

var _DetailHeights = _interopRequireDefault(require("FileManagerLib/reducers/DetailHeights"));

var _withHistory = _interopRequireDefault(require("FileManagerLib/reducers/withHistory"));

var _Shutterstock = _interopRequireDefault(require("FileManagerCore/reducers/Shutterstock"));

var _Configuration = _interopRequireDefault(require("FileManagerLib/reducers/Configuration"));

var _EditFile = _interopRequireDefault(require("FileManagerLib/reducers/EditFile"));

var _EditAndCreateImage = _interopRequireDefault(require("FileManagerCore/reducers/EditAndCreateImage"));

var _FileManagerPortalData = _interopRequireDefault(require("FileManagerCore/reducers/FileManagerPortalData"));

var _IdentityRepository = _interopRequireDefault(require("FileManagerCore/reducers/IdentityRepository"));

var _VideoThumbnails = _interopRequireDefault(require("FileManagerCore/reducers/VideoThumbnails"));

var _Filter = _interopRequireDefault(require("FileManagerLib/reducers/Filter"));

var _ImageOptimizationSettings = _interopRequireDefault(require("FileManagerLib/reducers/ImageOptimizationSettings"));

var _default = (0, _redux.combineReducers)({
  auth: _Auth.default,
  configuration: _Configuration.default,
  canva: _Canva.default,
  dropbox: _Dropbox.default,
  editFile: _EditFile.default,
  editAndCreateImage: _EditAndCreateImage.default,
  folders: _Folders.default,
  files: _Files.default,
  uploadingFiles: _UploadingFiles.default,
  detailHeights: _DetailHeights.default,
  panel: (0, _withHistory.default)(_Panel.default, [_ActionTypes.SEARCH, _ActionTypes.SELECT_FILE, _ActionTypes.SELECT_STOCK_FILE]),
  shutterstock: (0, _Shutterstock.default)({
    concatenateResults: true
  }),
  imageOptimizationSettings: _ImageOptimizationSettings.default,
  userSettings: _UserSettings.default,
  identityRepository: _IdentityRepository.default,
  fileManagerPortalData: _FileManagerPortalData.default,
  limits: _Limits.default,
  videoThumbnail: _VideoThumbnails.default,
  filter: _Filter.default
});

exports.default = _default;
module.exports = exports.default;